import { useJoinRequestNotifications } from 'hooks/useJoinRequestNotifications';

/** Mount once for authenticated users to surface join-request accept/decline feedback. */
const JoinRequestNotificationListener = () => {
  useJoinRequestNotifications();
  return null;
};

export default JoinRequestNotificationListener;
